module.exports = __webpack_public_path__ + "static/2-def73c19a1bc9d53f3daf2c955089cee.jpg";